module.exports = __webpack_public_path__ + "static/polygon_shape-88e824c2c0ecf1ecf3f30cc0fb5a57f5.png";